module.exports = __webpack_public_path__ + "static/media/rectangle.5892e598.svg";